const TransactionStatus = Object.freeze({
  OPEN: 'Pending',
  APPROVED: 'Accepted',
  REJECTED: 'Rejected',
});

export default TransactionStatus;
